export default {
  primary: '#09CC96',
  background: '#343434',
  secondaryBackground:'#2c2c2c',
  primaryText: '#fff',
  secondaryText: '#ffffff',
  boxShadow: 'none',
}